import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  static values = {
    sanitize: { type: Boolean, default: true }
  }

  connect() {
    this.popover = new Popover(this.element, {
      sanitize: this.sanitizeValue,
    })
  }

  disconnect() {
    if (this.popover) {
      this.popover.dispose()
    }
  }
}
